export default __webpack_public_path__ + "static/media/contact.70f58cd8.svg";